import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import * as AT from "./actionTypes";
import * as SELECTORS from "./selectors";
import { RootState } from "../../../../models";
import * as Ajax from "../../app/Ajax";
import * as GENERAL_A from "../../app/state/generalActions";
import { maskField } from "../../rapidform/formValidation";
import { API_URL_VOUCHERS_V2 } from "../api";
import TEXT from "../text-consts";
import { rule, mapVoucherValidationErrorMessage, VOUCHER_ERROR_CODES, VoucherErrorCode } from "../validation";

export const voucherError = (errorCode: VoucherErrorCode) => ({
    type: AT.VOUCHER_ERROR,
    validationMessage: mapVoucherValidationErrorMessage(errorCode),
});

export const onVoucherCodeChange = (code: string): ThunkAction<void, RootState, unknown, AnyAction> => {
    return function (dispatch, getState) {
        const previousCode = SELECTORS.getVoucherCode(getState());
        const maskedCode = maskField(code, previousCode, rule);
        dispatch({
            type: AT.VOUCHER_FORMAT_CODE,
            code: maskedCode,
        });
    };
};

export const addVoucherCode = (voucherCode: string): ThunkAction<void, RootState, unknown, AnyAction> => {
    return function (dispatch, getState) {
        // Empty ?
        if (!voucherCode) {
            dispatch(voucherError(VOUCHER_ERROR_CODES.VOUCHER_MISSING));
            return;
        }

        // Don't validate when using the voucher field to add discount
        // Invalid ?
        // if (validateField(voucherCode, rule)) {
        //     dispatch(voucherError(VOUCHER_ERROR_CODES.INVALID));
        //     return;
        // }

        // Already used ?
        const validatedVouchers = SELECTORS.getValidatedVouchers(getState());
        const isAlreadyRegistered = validatedVouchers.filter((voucher) => voucher.code === voucherCode).length > 0;
        if (isAlreadyRegistered) {
            dispatch(voucherError(VOUCHER_ERROR_CODES.VOUCHER_ALREADY_ADDED));
            return;
        }

        // All good. Submit voucher.
        const payload = Ajax.get(
            {
                url: `${API_URL_VOUCHERS_V2}/${voucherCode}`,
                retry: false,
            },
            dispatch,
        );

        dispatch({
            type: AT.VOUCHER_ADD,
            payload,
        });

        return payload;
    };
};

export const updateVouchers = (): ThunkAction<void, RootState, unknown, AnyAction> => {
    return function (dispatch) {
        const payload = Ajax.get(
            {
                url: `${API_URL_VOUCHERS_V2}/`,
                retry: false,
            },
            dispatch,
        );

        dispatch({
            type: AT.VOUCHER_UPDATED,
            payload,
        });

        payload.catch((error) => dispatch(voucherError(error.error)));
    };
};

export const removeVoucherCode = (voucherCode: string): ThunkAction<void, RootState, unknown, AnyAction> => {
    return function (dispatch) {
        const payload = Ajax.remove(
            {
                url: `${API_URL_VOUCHERS_V2}/${voucherCode}`,
                retry: false,
            },
            dispatch,
        );

        dispatch({
            type: AT.VOUCHER_REMOVE,
            payload,
        });

        payload.catch(() => dispatch(GENERAL_A.setNegativeFlash(TEXT.ERROR.CODE_NOT_REGISTRATED(voucherCode))));
    };
};
